<script setup>
import { computed } from 'vue';
import CFIcon from '@/ui/Icon/CFIcon.vue';
import CFMarkSubstring from '@/app/components/search/CFMarkSubstring.vue';

const props = defineProps({
    result: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
    query: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['select']);

const iconName = computed(() => {
    switch (props.result.item.type) {
        case 'domain':
            return 'network';
        case 'certificate':
            return 'ssl-lock';
        case 'contact':
            return 'single-neutral2';
        default:
            return 'common-file-text';
    }
});
</script>

<template>
    <button
        type="button"
        class="search-result-single relative flex w-full items-center gap-x-4 py-6 text-left"
        :class="{
            'is-active': isActive,
        }"
        @click="emit('select', result.item)"
    >
        <span class="bg-primary flex size-8 items-center justify-center rounded-full text-white">
            <CFIcon
                :name="iconName"
                class="size-5"
            />
        </span>
        <CFMarkSubstring
            :value="result.item.label"
            :query="query"
        />
        <span
            class="ml-auto inline-flex w-24 shrink-0 items-center justify-center bg-gray-100 px-3 py-1 text-xs text-gray-800"
        >
            {{ $t(`search.types.${result.item.type}`) }}
        </span>
    </button>
</template>

<style scoped>
@reference "@css/app.css";

.search-result-single::after {
    @apply absolute inset-0 top-4 block origin-top-right translate-x-0 translate-y-0 scale-x-0 scale-y-100 rotate-0 skew-x-0 skew-y-0 transform border-b border-current transition-transform duration-300;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    content: '';
}

.search-result-single.is-active::after {
    @apply origin-top-left translate-x-0 translate-y-0 scale-x-100 scale-y-100 rotate-0 skew-x-0 skew-y-0 transform;
}
</style>
